import { Injectable } from '@angular/core';
import { NgxPermissionsService } from 'ngx-permissions';
import { Config as MConfig } from '@uxdf/direct-shared-lib';
import { Observable, of } from 'rxjs';
import get from 'lodash/get';

export enum PermissionConfigList {
  CONFIG_CATALOG_ENABLED = 'CONFIG_CATALOG_ENABLED',
  CONFIG_NEWS_ENABLED = 'CONFIG_NEWS_ENABLED',
  CONFIG_DASHBOARD_ENABLED = 'CONFIG_DASHBOARD_ENABLED',
  CONFIG_AVC_DASHBOARD_ENABLED = 'CONFIG_AVC_DASHBOARD_ENABLED'
}

const permissionsMapping = {
  catalog: PermissionConfigList.CONFIG_CATALOG_ENABLED,
  news: PermissionConfigList.CONFIG_NEWS_ENABLED,
  dashboard: PermissionConfigList.CONFIG_DASHBOARD_ENABLED,
  'avc-dashboard': PermissionConfigList.CONFIG_AVC_DASHBOARD_ENABLED
};

@Injectable({
  providedIn: 'root'
})
export class PermissionHelper {
  constructor(private readonly permissionsService: NgxPermissionsService) {}

  setupPermissions(_config: MConfig): Observable<any> {
    this.permissionsService.addPermission(
      Object.keys(permissionsMapping).reduce((arr, key) => {
        if (get(_config, key + '.enabled', true)) {
          arr.push(permissionsMapping[key]);
        }
        return arr;
      }, [])
    );

    return of({
      config: _config,
      permissions: Object.keys(this.permissionsService.getPermissions())
    });
  }
}
